<template>
<svg :width="width" :height="height" viewBox="0 0 20 16" :fill="color" xmlns="http://www.w3.org/2000/svg">
<path d="M0.25 3.07143C0.25 2.243 0.92157 1.57143 1.75 1.57143H7.925C8.2185 1.57143 8.5056 1.4853 8.7507 1.32372L9.6243 0.74771C9.8694 0.58613 10.1565 0.5 10.45 0.5H18.25C19.0784 0.5 19.75 1.17157 19.75 2V12.9286C19.75 13.757 19.0784 14.4286 18.25 14.4286H12.075C11.7815 14.4286 11.4944 14.5147 11.2493 14.6763L10.3757 15.2523C10.1306 15.4139 9.8435 15.5 9.55 15.5H1.75C0.92157 15.5 0.25 14.8284 0.25 14V3.07143Z"  fill-opacity="0.3"/>
<path d="M7 9.5L8.5 10.25V11.75L7 12.5L5.5 11.75V10.25L7 9.5Z" fill="white"/>
<path d="M7.75 10.25V6.1053L12.25 5V9.1447" stroke="white" stroke-:width="1.5"/>
<path d="M11.5 8L13 8.75V10.25L11.5 11L10 10.25V8.75L11.5 8Z" fill="white"/>
</svg>

</template>

<script>
export default {
    props: {
        width: { type: [Number, String], default: 20 },
        height: { type: [Number, String], default: 16 },
        color: { type: String, default: "#D3D4DE" }
    }
}
</script>
